export default __webpack_public_path__ + "static/media/iphone_mockup.0b44a1f8.png";